<body *ngIf="background1" id="register_bg">
  <div class="o_authpage">
    <form [formGroup]="form">
      <ul>
        <li ><img src="/assets/img/logo-login.png" alt="" class="logo_sticky" height="60"></li>
        <li *ngIf="notSuccessMessage"><h1>Do you have access to {{organizationName}}?</h1></li>
        <li *ngIf="notSuccessMessage">
          <button class="btn btn-primary mb-2 px-4" type="button" (click)="denytocliend()">Deny</button>
          <button class="btn btn-primary mb-2 px-4" type="button" (click)="allowtocliend()">
            <span>Allow</span>
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm float-right"></span>
          </button>
        </li>
        <li *ngIf="showSuccessMessage">
          <p style="font-weight: bold;">Authentication successfully!</p>
        </li>
        <li style="margin-top: 50px;">© {{year}} {{organizationName}}</li>
      </ul>
    </form>
  </div>
</body>
<body *ngIf="background2" id="boyd_bg">
  <div class="o_authpage">
    <form [formGroup]="form">
      <ul>
        <li ><img src="/assets/img/boyd_gaming_logo.jpg" alt="" class="logo_sticky" height="60"></li>
        <li *ngIf="notSuccessMessage"><h1>Do you have access to {{organizationName}}?</h1></li>
        <li *ngIf="notSuccessMessage">
          <button class="btn btn-primary mb-2 px-4" type="button" (click)="denytoclient()">Deny</button>
          <button class="btn btn-primary mb-2 px-4" type="button" (click)="allowtoclient()">
            <span>Allow</span>
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm float-right"></span>
          </button>
        </li>
        <li *ngIf="showSuccessMessage">
          <p style="font-weight: bold;">Authentication successfully!</p>
        </li>
        <li style="margin-top: 50px;">© {{year}} {{organizationName}}</li>
      </ul>
    </form>
  </div>
</body>
